import { isLocale, negotiateLocale, type Locale } from "@omony/i18n";

/**
 * Oberflächen-Einstellungen je Gerät (Sprache, Theme). Nur Komfort – Speicher kann fehlen
 * (Kiosk, privater Modus), daher überall try/catch. `?lang=` und `?theme=` für Tests/Screenshots.
 */
export type ThemePref = "system" | "light" | "dark";

const read = (k: string): string | null => {
  try {
    return localStorage.getItem(k);
  } catch {
    return null;
  }
};
const write = (k: string, v: string) => {
  try {
    localStorage.setItem(k, v);
  } catch {
    /* ohne Speicher weiter */
  }
};

const query = () => new URLSearchParams(location.search);

export function initialLocale(): Locale {
  const q = query().get("lang");
  if (isLocale(q)) return q;
  const stored = read("omony.uiLanguage");
  if (isLocale(stored)) return stored;
  return negotiateLocale(navigator.languages ?? [navigator.language]);
}

export function storeLocale(l: Locale) {
  write("omony.uiLanguage", l);
}

export function initialTheme(): ThemePref {
  const q = query().get("theme");
  if (q === "light" || q === "dark" || q === "system") return q;
  const s = read("omony.theme");
  return s === "light" || s === "dark" ? s : "system";
}

export function applyTheme(t: ThemePref) {
  const root = document.documentElement;
  if (t === "system") delete root.dataset.theme;
  else root.dataset.theme = t;
}

export function storeTheme(t: ThemePref) {
  write("omony.theme", t);
}
